// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1cxRN","item":"PaymentsMobile_item__1UZrl","label":"PaymentsMobile_label__3pNyI","amount":"PaymentsMobile_amount__3WxCt"};